let elemVisu = document.querySelector('.slider-visu');
let flktyVisu = new Flickity( elemVisu, {
  cellAlign: 'left',
  contain: true,
  watchCSS: true,
  pageDots: false,
  prevNextButtons: false,
  autoPlay: 1500,
  fade: true
});

[].forEach.call(document.querySelectorAll('.slider-mob'), function(el) {
  let flktyMob = new Flickity( el, {
    cellAlign: 'left',
    contain: true,
    watchCSS: true,
    pageDots: false,
    wrapAround: true,
    prevNextButtons: true,
    arrowShape: 'm95.24,47.82H10.15l16.51-16.51c.88-.88.88-2.32,0-3.2s-2.32-.88-3.2,0L3.19,48.37c-.42.42-.66,1-.66,1.6s.24,1.18.66,1.6l20.27,20.27c.44.44,1.02.66,1.6.66s1.16-.22,1.6-.66c.88-.88.88-2.32,0-3.2l-16.29-16.29h84.86c1.25,0,2.26-1.01,2.26-2.26s-1.01-2.26-2.26-2.26Z'
  });
});


[].forEach.call(document.querySelectorAll('.nav-icons__item'), function(el) {
  el.addEventListener('click', function() {
    let navIconsActive = document.querySelector('.nav-icons__item--active');
    navIconsActive.classList.remove('nav-icons__item--active');
    el.classList.add('nav-icons__item--active');

    let blockIconsActive = document.querySelector('.block--active');
    blockIconsActive.classList.remove('block--active');
    let blockIcons = el.getAttribute('data-nav');
    document.querySelector('.' + blockIcons).classList.add('block--active');
  })
});

[].forEach.call(document.querySelectorAll('.dim-icons .icons-essentiel .container'), function(el) {
  el.style.display = "none";
});